import { Element } from "@xmpp/xml"
import { FUEL_STATIONS_NS, FuelStation } from "@/lib/fuelStations"

export type FuelStationsResult = {
  stations: FuelStation[]
  vhost?: string
}

export default class FuelStationsParser {
  static parse(stanza: Element): FuelStationsResult | undefined {
    if (stanza.name !== "iq") return

    const command = stanza.getChild(
      "command",
      "http://jabber.org/protocol/commands",
    )
    if (!command) return

    const fuelStationsElement = command.getChild(
      "fuel-stations",
      FUEL_STATIONS_NS,
    )
    if (!fuelStationsElement) return

    const stations = fuelStationsElement
      .getChildren("station", FUEL_STATIONS_NS)
      .flatMap((station) => {
        const lat = Number.parseFloat(station.getAttr("lat") ?? "")
        const lon = Number.parseFloat(station.getAttr("lon") ?? "")
        const color = station.getAttr("color")

        if (!Number.isFinite(lat) || !Number.isFinite(lon) || !color) {
          return []
        }

        const icon = station.getAttr("icon")
        const category = station.getAttr("category")

        return [
          {
            lat,
            lon,
            color,
            ...(icon ? { icon } : {}),
            ...(category ? { category } : {}),
            name: station.getAttr("name") ?? "",
            address: station.getAttr("address") ?? "",
          },
        ]
      })

    return {
      stations,
      vhost: fuelStationsElement.getAttr("vhost") ?? undefined,
    }
  }
}
